import clsx from 'clsx'
import map from 'lodash/map'
import React, { FC } from 'react'

import { ImageV4 } from '@Components/Image'
import { Wordbook } from '@Components/Wordbook'
import { ImageResource, InfoPanelBlock as InfoPanelBlockGraphQL } from '@Generated/graphql'

import styles from './InfoPanelBlock.module.scss'

export interface InfoPanelBlockProps {
  block: InfoPanelBlockGraphQL
  id?: string
}

const InfoPanelBlock: FC<InfoPanelBlockProps> = ({ block, id }) => (
  <>
    {block.common?.title && (
      <>
        {block.common?.titleElement === 'h1' && <h1 className={styles.infoPanelBlockHeader}>{block.common.title}</h1>}
        {block.common?.titleElement === 'h2' && <h2 className={styles.infoPanelBlockHeader}>{block.common.title}</h2>}
        {block.common?.titleElement === 'h3' && <h3 className={styles.infoPanelBlockHeader}>{block.common.title}</h3>}
        {block.common?.titleElement === 'h4' && <h4 className={styles.infoPanelBlockHeader}>{block.common.title}</h4>}
        {block.common?.titleElement === 'h5' && <h5 className={styles.infoPanelBlockHeader}>{block.common.title}</h5>}
      </>
    )}
    <div className={clsx(styles.infoPanelBlock)} id={id}>

      {map(block.infoPanels, infoPanel => (
        <div key={`ClubStep_${infoPanel?.subTitle?.value}_${infoPanel.title?.value}`} className={clsx(styles.clubInfoItem)}>
          {(infoPanel.icon as ImageResource)?.image?.url && <ImageV4 src={(infoPanel.icon as ImageResource).image?.url!} width={40} />}
          <p className={styles.title}>
            <Wordbook wordbook={infoPanel.title} />
          </p>
          <p className={styles.subTitle}>
            <Wordbook wordbook={infoPanel.subTitle} />
          </p>
          <p className={styles.text}>
            <Wordbook wordbook={{ ...infoPanel.text, values: { percentage: '15' } }} />
          </p>
        </div>
      ))}
    </div>
  </>
)

export default InfoPanelBlock
